/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Actions/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import Compare from './Compare/index'
import Delete from './Delete/index'
import Edit from './Edit/index'
import LauncherModalFullscreen from './LauncherModalFullscreen/index'
import Launchers from './Launchers/index'
import LinkedDocumentModalFullscreen from './LinkedDocumentModalFullscreen/index'
import LinkedDocuments from './LinkedDocuments/index'
import Options from './Options/index'
import Popover from 'DesignSystem/Popover/index'
import PopoverContent from 'DesignSystem/Popover/PopoverContent/index'
import PopoverTrigger from 'DesignSystem/Popover/PopoverTrigger/index'
import React from 'react'
import SendSecurely from './SendSecurely/index'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonIcon from 'DesignSystem/TysiaButton/TysiaButtonIcon/index'
import TysiaIconMoreHoriz from 'DesignSystem/Svgs/TysiaIconMoreHoriz/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Actions({
  children,
  viewPath = "/DesignSystem/ImageCard/Content/Content/Actions",
  isHovered
  
}) {
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
let dtColorsNeutral200 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.200'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
  return (<React.Fragment
>
<div
  data-testid="Actions.Vertical"
  data-view-path={viewPath}
 style={{'--o-1-AjnkD': isHovered ? 1 : 0}}
 className={`views-block ${styles.Vertical}`}
>
<Popover
  viewPath={`${viewPath}/Popover`}
>
{childProps => (
<React.Fragment>
<PopoverTrigger
{...childProps}
  viewPath={`${viewPath}/PopoverTrigger`}
>
{childProps => (
<TysiaButton
{...childProps}
  viewPath={`${viewPath}/TysiaButton`}
 type="secondary"
 size="small"
>
{childProps => (
<TysiaButtonIcon
{...childProps}
  viewPath={`${viewPath}/TysiaButtonIcon`}
>
{childProps => (
<TysiaIconMoreHoriz
{...childProps}
  viewPath={`${viewPath}/TysiaIconMoreHoriz`}
 width={dtSpaceS}
 height={dtSpaceS}
/>
)}
</TysiaButtonIcon>
)}
</TysiaButton>
)}
</PopoverTrigger>
<PopoverContent
{...childProps}
  viewPath={`${viewPath}/PopoverContent`}
 width={240}
>
{childProps => (
<div
  data-testid="Actions.Vertical:1"
  data-view-path={viewPath}
 style={{'--bc-2-AjnkD': dtColorsWhite,'--bc-3-AjnkD': dtColorsNeutral200,'--btlr-4-AjnkD': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--btrr-5-AjnkD': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--bblr-6-AjnkD': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--bbrr-7-AjnkD': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pb-8-AjnkD': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pt-9-AjnkD': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block new-shadow ${styles.Vertical1}`}
>
<Options
  viewPath={`${viewPath}/Options`}
/>
<LinkedDocuments
  viewPath={`${viewPath}/LinkedDocuments`}
/>
<Launchers
  viewPath={`${viewPath}/Launchers`}
/>
</div>
)}
</PopoverContent>
</React.Fragment>
)}
</Popover>
</div>
<SendSecurely
  viewPath={`${viewPath}/SendSecurely`}
/>
<Edit
  viewPath={`${viewPath}/Edit`}
/>
<Delete
  viewPath={`${viewPath}/Delete`}
/>
<Compare
  viewPath={`${viewPath}/Compare`}
/>
<LauncherModalFullscreen
  viewPath={`${viewPath}/LauncherModalFullscreen`}
/>
<LinkedDocumentModalFullscreen
  viewPath={`${viewPath}/LinkedDocumentModalFullscreen`}
/>
{children}
</React.Fragment>)
}